<template>
  <div>
    <div class="is-clickable" @click="open = true">
      <a>
        <span v-if="!value || !stockingUnitId">
          Select a product
        </span>
        <span v-else>
          <div>
            {{ product.name }}
          </div>
          <div 
            class="help"
            v-if="category.has_dimensions || product.size">
            <template v-if="category.has_dimensions">
              {{ lwt(stockingUnit) }}
            </template>
            <template v-else>
              {{ product.size }}
            </template>
          </div>  
        </span>
      </a>
    </div>

    <div
      class="modal"
      :class="{ 'is-active': open }">

      <div class="modal-background"
        @click="close()">
      </div>
      
      <div class="modal-content">

        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Select A Product</p>
            <button
              class="delete"
              aria-label="close"
              @click="close()">
            </button>
          </header>

          <v-form 
            :valid.sync="valid"
            class="modal-card-body pb-5">

            <div class="field">
              <label class="label">Product Category*</label>
              <v-select
                v-if="categories.length > 0"
                required
                :options="categories"
                item-value="id"
                item-text="category"
                v-model="categoryId"
              />
            </div>

            <div class="field">
              <label class="label">Product*</label>
              <template v-if="categoryId">
                <v-select
                  v-if="!loading && products.length > 0"
                  required
                  :options="products"
                  item-value="id"
                  item-text="name"
                  v-model="productId"
                />
                <span v-else class="has-text-grey-light">
                  No products in this category
                </span>
              </template>
              <span v-else class="has-text-grey-light">
                Please select a category
              </span>
            </div>
            
            <div class="field">
              <label class="label">Product Size*</label>
              <template v-if="productId">
                <template v-if="category.has_dimensions">
                  <v-select
                    v-if="stockingUnits.length > 1"
                    required
                    :options="stockingUnits"
                    item-value="id"
                    :item-text="(d) => { return lwt(d) }"
                    v-model="stockingUnitId"
                  />
                  <span v-else>
                    {{ lwt(stockingUnits[0]) }}
                  </span>
                </template>
                <template v-else>
                  <span v-if="product.size">
                    {{ product.size }}
                  </span>
                  <span v-else class="has-text-grey">
                    No product size
                  </span>
                </template>
              </template>
              <span v-else class="has-text-grey-light">
                Please select a product
              </span>
            </div>

          </v-form>

          <footer class="modal-card-foot">
            <button 
              class="button is-primary" 
              @click.stop="selectProduct()">
              Select Product
            </button>
            <button 
              class="button" 
              @click.stop="close(true)">
              Cancel
            </button>
          </footer>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VForm from '@/components/base/VForm'
import VSelect from '@/components/base/VSelect'

import { mapState, mapActions } from 'vuex'

export default {
  components: { VSelect, VForm },
  props: {
    value: {
      type: [String, Number]
    }
  },
  data() {
    return {
      open: false,
      categoryId: null,
      productId: null,
      stockingUnitId: null,
      products: [],
      loading: false,
      valid: false
    }
  },
  computed: {
    ...mapState("products", ["categories"]),
    category() {
      return this.categories.filter(d => d.id == this.categoryId)[0];
    },
    product() {
      return this.products.filter(d => d.id == this.productId)[0];
    },
    stockingUnits() {
      return this.product.stocking_units;
    },
    stockingUnit() {
      return this.stockingUnits.filter(d => d.id == this.value)[0];
    }
  },
  watch: {
    categoryId(id) {
      this.$emit('input', null);
      this.productId = null;
      this.loading = true;
      this.$http.products.get({ product_category_id: id })
        .then(resp => {
          this.loading = false;
          this.products = resp.data.results;
        })
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("products", ["getCategories"]),
    initialize() {
      if (this.categories.length == 0) {
        this.getCategories();
      }
    },
    lwt(v) {
      return `L${v.length_in_str}" x W${v.width_in_str}" x T${v.thick_in_str}"`
    },
    changedStockingUnit(v) {
      this.$emit('input', v);
    },
    selectProduct() {
      if (!this.category.has_dimensions || this.stockingUnits.length == 1) {
        this.$emit('input', this.stockingUnits[0].id);
      } else {
        this.$emit('input', this.stockingUnitId);
      }

      this.close();
    },
    close(clear=false) {
      this.open = false;
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>


<style scoped>
.modal-card {
  border-radius: 6px;
}

.is-clickable {
  cursor: pointer;
}
</style>